const riot = require('riot');

riot.tag2('module-provider-test_point_provider', '<div class="text-center ts-h1 mb24">検証用ポイントサービス</div> <div class="text-center text-gray_80 ts-ps">これは検証用のダミー受け取り画面です</div>', 'module-provider-test_point_provider,[data-is="module-provider-test_point_provider"]{display:block}', '', function(opts) {
});